export default __webpack_public_path__ + "static/media/tetrahedron.4de7442d.png";